// Theme color constants for CardChase1

export const darkTheme = {
  // Backgrounds
  bg: '#0a0a0a',
  bgPure: '#000000',
  bgCard: '#1a1a1a',
  bgSheet: '#151515',
  bgHover: '#252525',
  bgInput: '#1a1a1a',

  // Borders
  border: '#2a2a2a',
  borderHover: '#3a3a3a',
  borderSubtle: '#1a1a1a',

  // Text
  text: '#ffffff',
  textMuted: '#94a3b8',
  textSecondary: '#6a6a6a',
  textDisabled: '#4a4a4a',

  // Primary accent (cyan)
  accent: '#0ea5e9',
  accentHover: '#0284c7',
  accentLight: '#38bdf8',
  accentBg: 'rgba(14, 165, 233, 0.15)',

  // Status colors
  error: '#ef4444',
  errorBg: 'rgba(239, 68, 68, 0.15)',
  success: '#22c55e',
  successBg: 'rgba(34, 197, 94, 0.15)',
  warning: '#f59e0b',
  warningDark: '#d97706',
  warningBg: 'rgba(245, 158, 11, 0.15)',

  // Special colors
  purple: '#8b5cf6',
  purpleDark: '#7c3aed',
  purpleBg: 'rgba(139, 92, 246, 0.15)',

  // Shadows (minimal in dark mode)
  shadow: 'none',
  shadowCard: 'none',
  shadowNav: 'none',

  // Overlay
  overlay: 'rgba(0, 0, 0, 0.8)',
  overlayLight: 'rgba(0, 0, 0, 0.6)',
};

export const lightTheme = {
  // Backgrounds
  bg: '#f8fafc',
  bgPure: '#ffffff',
  bgCard: '#ffffff',
  bgSheet: '#f1f5f9',
  bgHover: '#e2e8f0',
  bgInput: '#ffffff',

  // Borders
  border: '#e2e8f0',
  borderHover: '#cbd5e1',
  borderSubtle: '#f1f5f9',

  // Text
  text: '#0f172a',
  textMuted: '#94a3b8',
  textSecondary: '#64748b',
  textDisabled: '#cbd5e1',

  // Primary accent (slightly darker for contrast)
  accent: '#0284c7',
  accentHover: '#0369a1',
  accentLight: '#0ea5e9',
  accentBg: 'rgba(2, 132, 199, 0.1)',

  // Status colors (slightly darker for white bg)
  error: '#dc2626',
  errorBg: 'rgba(220, 38, 38, 0.1)',
  success: '#16a34a',
  successBg: 'rgba(22, 163, 74, 0.1)',
  warning: '#d97706',
  warningDark: '#b45309',
  warningBg: 'rgba(217, 119, 6, 0.1)',

  // Special colors
  purple: '#7c3aed',
  purpleDark: '#6d28d9',
  purpleBg: 'rgba(124, 58, 237, 0.1)',

  // Shadows (important in light mode)
  shadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  shadowCard: '0 2px 8px rgba(0, 0, 0, 0.08)',
  shadowNav: '0 -2px 10px rgba(0, 0, 0, 0.05)',

  // Overlay
  overlay: 'rgba(0, 0, 0, 0.5)',
  overlayLight: 'rgba(0, 0, 0, 0.3)',
};

export const themes = {
  dark: darkTheme,
  light: lightTheme,
};
